import { signInWithCustomToken, type User } from "firebase/auth";

import { apiClient } from "@/api/api";
import { auth } from "@/config/firebase";

let authenticationPromise: Promise<User> | null = null;

export const ensureStorageAuthenticated = async (): Promise<User> => {
  await auth.authStateReady();

  if (auth.currentUser) {
    return auth.currentUser;
  }

  if (!authenticationPromise) {
    authenticationPromise = apiClient
      .get<{ firebaseToken?: string }>("/refresh", {
        withCredentials: true,
      })
      .then(async ({ data }) => {
        if (!data.firebaseToken) {
          throw new Error("The backend did not return a Firebase storage token.");
        }

        const credential = await signInWithCustomToken(auth, data.firebaseToken);
        return credential.user;
      })
      .finally(() => {
        authenticationPromise = null;
      });
  }

  return authenticationPromise;
};
